import { lazy } from "react";
import { Route } from "react-router-dom";
import RouteGuard from "@/components/RouteGuard";

const SuperAdminDashboard = lazy(() => import("@/pages/SuperAdminDashboard"));
const SuperAdminAcademiasLista = lazy(() => import("@/pages/SuperAdminAcademiasLista"));
const CadastroAcademia = lazy(() => import("@/pages/CadastroAcademia"));
const AcademiaDetalhe = lazy(() => import("@/pages/AcademiaDetalhe"));
const SuperAdminAcademiaEditar = lazy(() => import("@/pages/SuperAdminAcademiaEditar"));
const SuperAdminAdminsLista = lazy(() => import("@/pages/SuperAdminAdminsLista"));
const SuperAdminAdminDetalhe = lazy(() => import("@/pages/SuperAdminAdminDetalhe"));
const SuperAdminProfessoresLista = lazy(() => import("@/pages/SuperAdminProfessoresLista"));
const SuperAdminProfessorDetalhe = lazy(() => import("@/pages/SuperAdminProfessorDetalhe"));
const SuperAdminAlunosLista = lazy(() => import("@/pages/SuperAdminAlunosLista"));
const SuperAdminAlunoDetalhe = lazy(() => import("@/pages/SuperAdminAlunoDetalhe"));
const SuperAdminTurmasLista = lazy(() => import("@/pages/SuperAdminTurmasLista"));
const SuperAdminTurmaDetalhe = lazy(() => import("@/pages/SuperAdminTurmaDetalhe"));
const SuperAdminFinanceiroDashboard = lazy(() => import("@/pages/SuperAdminFinanceiroDashboard"));
const SuperAdminCobrancaDetalhe = lazy(() => import("@/pages/SuperAdminCobrancaDetalhe"));
const SuperAdminRelatoriosFinanceiros = lazy(() => import("@/pages/SuperAdminRelatoriosFinanceiros"));
const SuperAdminPlanoFinanceiro = lazy(() => import("@/pages/SuperAdminPlanoFinanceiro"));
const ImportarAlunos = lazy(() => import("@/pages/ImportarAlunos"));
const SuperAdminRedesLista = lazy(() => import("@/pages/SuperAdminRedesLista"));
const SuperAdminSecurityDashboard = lazy(() => import("@/pages/SuperAdminSecurityDashboard"));
const SuperAdminEmailHealth = lazy(() => import("@/pages/SuperAdminEmailHealth"));

const roles = ["developer", "super_admin"] as const;
const G = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={[...roles]}>{children}</RouteGuard>
);

export const superAdminRoutes = (
  <>
    <Route path="/superadmin_importar_alunos" element={<G><ImportarAlunos /></G>} />
    <Route path="/superadmin_redes" element={<G><SuperAdminRedesLista /></G>} />
    <Route path="/superadmin_seguranca" element={<G><SuperAdminSecurityDashboard /></G>} />
    <Route path="/superadmin_email_health" element={<G><SuperAdminEmailHealth /></G>} />
    <Route path="/superadmin_dashboard" element={<G><SuperAdminDashboard /></G>} />
    <Route path="/superadmin_academias" element={<G><SuperAdminAcademiasLista /></G>} />
    <Route path="/superadmin_academia_nova" element={<G><CadastroAcademia /></G>} />
    <Route path="/superadmin_academia_detalhe" element={<G><AcademiaDetalhe /></G>} />
    <Route path="/superadmin_academia_editar" element={<G><SuperAdminAcademiaEditar /></G>} />
    <Route path="/superadmin_academia/:id/editar" element={<G><SuperAdminAcademiaEditar /></G>} />
    <Route path="/superadmin_academia_admins" element={<G><SuperAdminAdminsLista /></G>} />
    <Route path="/superadmin_admin_detalhe" element={<G><SuperAdminAdminDetalhe /></G>} />
    <Route path="/superadmin_admin/:id" element={<G><SuperAdminAdminDetalhe /></G>} />
    <Route path="/superadmin_academia_professores" element={<G><SuperAdminProfessoresLista /></G>} />
    <Route path="/superadmin_professor_detalhe" element={<G><SuperAdminProfessorDetalhe /></G>} />
    <Route path="/superadmin_professor/:id" element={<G><SuperAdminProfessorDetalhe /></G>} />
    <Route path="/superadmin_academia_alunos" element={<G><SuperAdminAlunosLista /></G>} />
    <Route path="/superadmin_aluno_detalhe" element={<G><SuperAdminAlunoDetalhe /></G>} />
    <Route path="/superadmin_aluno/:id" element={<G><SuperAdminAlunoDetalhe /></G>} />
    <Route path="/superadmin_academia_turmas" element={<G><SuperAdminTurmasLista /></G>} />
    <Route path="/superadmin_turma_detalhe" element={<G><SuperAdminTurmaDetalhe /></G>} />
    <Route path="/superadmin_turma/:id" element={<G><SuperAdminTurmaDetalhe /></G>} />
    <Route path="/superadmin_academia_financeiro" element={<G><SuperAdminFinanceiroDashboard /></G>} />
    <Route path="/superadmin_cobranca_detalhe" element={<G><SuperAdminCobrancaDetalhe /></G>} />
    <Route path="/superadmin_cobranca/:id" element={<G><SuperAdminCobrancaDetalhe /></G>} />
    <Route path="/superadmin_relatorios_financeiros" element={<G><SuperAdminRelatoriosFinanceiros /></G>} />
    <Route path="/superadmin_plano_financeiro" element={<G><SuperAdminPlanoFinanceiro /></G>} />
  </>
);
